import { render, staticRenderFns } from "./cabinet-requests-list-secondary-item.vue?vue&type=template&id=f343091c&scoped=true&"
import script from "./cabinet-requests-list-secondary-item.vue?vue&type=script&lang=js&"
export * from "./cabinet-requests-list-secondary-item.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-requests-list-secondary-item.vue?vue&type=style&index=0&id=f343091c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f343091c",
  null
  
)

export default component.exports